import React from "react";
import { CalendarPlus, Compass, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function MarinaMobileQuickActions({ marina, lat, lng }) {
  const canNavigate = Number.isFinite(lat) && Number.isFinite(lng);
  return (
    <div className="fixed inset-x-0 bottom-0 z-20 border-t border-white/10 bg-slate-950/90 p-3 text-white backdrop-blur-2xl md:hidden">
      <div className="grid grid-cols-3 gap-2">
        {canNavigate ? <Button asChild size="sm"><a href={`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`} target="_blank" rel="noopener noreferrer"><Compass className="h-4 w-4" /> Go</a></Button> : <Button size="sm" disabled>Go</Button>}
        <Button asChild={!!marina.phone} size="sm" variant="outline">{marina.phone ? <a href={`tel:${marina.phone}`}><Phone className="h-4 w-4" /> Call</a> : <span><Phone className="h-4 w-4" /> Call</span>}</Button>
        <Button size="sm" variant="outline"><CalendarPlus className="h-4 w-4" /> Book</Button>
      </div>
    </div>
  );
}